export default "__VITE_ASSET__tFueuIWz__"